import React from "react";

function SavingsCard({ list }) {
  return (
    <div
      className="px-[13px] pt-[13px] pb-5 rounded-[15px] min-w-[242px] md:w-[242px]"
      style={{ backgroundColor: list?.bgcolor, boxShadow: list?.boxShadow }}
    >
      <div className="relative flex justify-center items-center w-[62px] h-[62px]">
        <div
          className="w-[62px] h-[62px] rounded-full absolute shadow-customcombined"
          style={{
            backgroundColor: list?.circularbg,
            boxShadow: list?.divshadow,
          }}
        ></div>
        <div className="relative flex justify-center items-center w-[48px] h-[48px]">
          <img
            src={list?.inner}
            alt="inner"
            width={48}
            height={48}
            className="absolute z-[2]"
          />
          <img
            src={list?.icon}
            alt="icon"
            width={31}
            height={31}
            className="absolute z-[5]"
          />
        </div>
      </div>
      <div className="mt-[13px] text-ivygray font-AktivGrotesk font-normal text-lg leading-[23px]">
        {list?.title}
      </div>
    </div>
  );
}

export default SavingsCard;
